import React, { useState, useEffect } from "react";
import { Row, Col } from "reactstrap";
import {
  GridComponent,
  Inject,
  ColumnDirective,
  ColumnsDirective,
  CommandColumn,
  Page,
  Filter,
  Toolbar,
  ExcelExport,
  Sort,
  Resize,
  Group,
  Freeze,
} from "@syncfusion/ej2-react-grids";
import { useBarcodeStore } from "../../../store/useBarcodeMasterStore";

const mockApiResponse = [
  {
    tableid: 1,
    StoreCode: "20003",
    StoreName: "Malleswaram Mantri",
    type: "New Liquidation",
    POPULATED_DATE: "05-Dec-2025",
    MARKET_NAME: "Edible Oil / Fats",
    ITEM: 100000669,
    ITEM_DESC: "HERITAGE COW GHEE POLY POUCH 475ML",
    GRN_BUCKET: "91-120",
    SOH: 19,
    Updated_SOH: 19,
    MANUFACTURE_DATE: "",
    MRP: 375,
    Updated_MRP: 375,
    IsUpdated: "UPDATED",
    UpdatedByName: "20003",
    UpdatedOn: "09-Dec-2025 04:02:28 PM",
    IsApproved: "APPROVED",
    ApprovedByName: "Mukunda Mishra",
    ApprovedOn: "09-Dec-2025 04:08:07 PM",
    BarCodePrintStatusName: "Printed",
    PrintByName: "20003",
    PrintOn: "09-Dec-2025 04:19:47 PM",
    OfferPrice: 300,
  },
  {
    tableid: 3,
    StoreCode: "20003",
    StoreName: "Malleswaram Mantri",
    POPULATED_DATE: "05-Dec-2025",
    MARKET_NAME: "MH-Beverages-Hot",
    ITEM: 100000815,
    type: "New Liquidation",
    ITEM_DESC: "TATA TEA GOLD 1 KG",
    GRN_BUCKET: "181-270",
    SOH: 6,
    Updated_SOH: 6,
    MANUFACTURE_DATE: "",
    MRP: 540,
    Updated_MRP: 600,
    IsUpdated: "UPDATED",
    UpdatedByName: "20003",
    UpdatedOn: "09-Dec-2025 05:36:33 PM",
    IsApproved: "APPROVED",
    ApprovedByName: "Mukunda Mishra",
    ApprovedOn: "09-Dec-2025 05:43:08 PM",
    BarCodePrintStatusName: "Printed",
    PrintByName: "20003",
    PrintOn: "09-Dec-2025 05:47:44 PM",
    OfferPrice: 400,
  },
];

const BasicGrid = ({}) => {
  const [userDetails, setUserDetails] = useState([]);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
    const { finalList } = useBarcodeStore();


 
    useEffect(() => {
      if (finalList && finalList.length > 0) {
        const dataWithSerial = finalList.map((item, index) => ({
          ...item,
          serialNo: index + 1,
  
          PopulatedDate: item.PopulatedDate ? new Date(item.PopulatedDate) : null,
  
          ManufactureDate: item.ManufactureDate
            ? new Date(item.ManufactureDate)
            : null,
  
          UpdatedOn: item.UpdatedOn ? new Date(item.UpdatedOn) : null,
          ApprovedOn: item.ApprovedOn ? new Date(item.ApprovedOn) : null,
        }));
  
        setUserDetails(dataWithSerial);
      } else {
        setUserDetails([]);
      }
    }, [finalList]);
  let gridInstance;

  const toolbarClick = (args) => {
    if (gridInstance && args.item.id === "BrokerGrid_excelexport") {
      gridInstance.excelExport();
    }
  };

  return (
    <>
      <div
        className={`grid_compact ${isMobile ? "e-bigger" : ""}`}
        style={{
          position: "relative",
          marginTop: "10px",
          background: "#fff",
          borderRadius: 12,
          boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
          padding: "6px",
          marginBottom: "20px",
        }}
      >
        <Row>
          <Col>
            <GridComponent
              ref={(g) => (gridInstance = g)}
              id="BrokerGrid"
              dataSource={userDetails}
              allowPaging={true}
              allowSorting={true}
              allowFiltering={true}
              filterSettings={{ type: "Excel" }}
              toolbar={["ExcelExport", "Search"]}
              allowExcelExport={true}
              toolbarClick={toolbarClick}
              enableAdaptiveUI={isMobile}
              rowRenderingMode={isMobile ? "Vertical" : "Horizontal"}
              gridLines="Both"
              height={"300px"}
              pageSettings={{
                pageSizes: [10, 20, 30, 40, 50, "All"],
                pageCount: 10,
              }}
              rowHeight={isMobile ? "" : 32}
              allowResizing={true}
              dataBound={() => {
                if (!isMobile && gridInstance) {
                  gridInstance.autoFitColumns();
                }
              }}
              // frozenColumns={1}
              // rowDataBound={()}
              // commandClick={handleCommandClick}
            >
              <ColumnsDirective>
                <ColumnDirective
                  field="serialNo"
                  headerText="S No"
                  width="90"
                  textAlign="Center"
                  allowFiltering={false}
                />
                <ColumnDirective
                  field="PopulatedDate"
                  headerText="Populated Date"
                  type="date"
                  format="dd/MM/yyyy"
                  width="250"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="StoreCode"
                  headerText="Store Code"
                  width="200"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="StoreName"
                  headerText="Store Name"
                  width="200"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="ItemCode"
                  headerText="Item Code"
                  width="200"
                  textAlign="Left"
                />
                
                <ColumnDirective
                  field="ShortDesc"
                  headerText="Short Desc"
                  width="250"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="DivisionName"
                  headerText="Division Name"
                  width="150"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="GrnBucket"
                  headerText="Grn Bucket"
                  textAlign="Left"
                  width="180"
                />
                <ColumnDirective
                  field="SOH"
                  headerText="SOH"
                  width="180"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="UpdatedSOH"
                  headerText="Updated SOH"
                  width="150"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="Total_SOH"
                  headerText="Total SOH"
                  width="180"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="ManufactureDate"
                  headerText="Manufacture Date"
                  type="date"
                  format="dd/MM/yyyy"
                  width="250"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="Discount"
                  headerText="Discount"
                  width="150"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="Mrp"
                  headerText="MRP"
                  width="180"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="UpdatedMrp"
                  headerText="Updated MRP"
                  width="200"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="UpdatedBy"
                  headerText="Updated By"
                  width="180"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="UpdatedOn"
                  headerText="Updated On"
                  type="date"
                  format="dd/MM/yyyy"
                  width="180"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="Updated"
                  headerText="Updated Status"
                  width="170"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="Approved"
                  headerText="Approved Status"
                  width="200"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="Name"
                  headerText="Approved By"
                  width="180"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="ApprovedOn"
                  headerText="Approved On"
                  width="180"
                  type="date"
                  format="dd/MM/yyyy"
                  textAlign="Left"
                />
                
              </ColumnsDirective>

              <Inject
                services={[
                  CommandColumn,
                  Page,
                  Filter,
                  Toolbar,
                  ExcelExport,
                  Sort,
                  Group,
                  Resize,
                  Freeze,
                ]}
              />
            </GridComponent>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default BasicGrid;
